import * as React from 'react'
import { ReactElement } from 'react'
import { Button, mergeClasses, Text } from '@fluentui/react-components'
import { OpenRegular } from '@fluentui/react-icons'
import { ViewFileProps } from '../ViewFile'
import { useApplicationStyles } from '../../../../pages/App'
import { useTranslation } from 'react-i18next'
import { AIAgentSummaryDto, FileAIAgentDto, FileAIAgentProps } from './FileAIAgentOverview'
import { RichText } from '../../../components/Text/RichText'

export function FileAIAgentSummary(
    props: Partial<FileAIAgentProps> & ViewFileProps & { currentAIAgent: FileAIAgentDto; summary: AIAgentSummaryDto },
): ReactElement {
    const appStyles = useApplicationStyles()
    const { t: translate } = useTranslation()

    return (
        <div className={mergeClasses(appStyles.flexColumn, appStyles.gapS)}>
            <div className={mergeClasses(appStyles.flexRow, appStyles.gapS)}>
                <Button
                    appearance="secondary"
                    icon={<OpenRegular />}
                    onClick={() =>
                        window.open(
                            `${process.env.LEGALPA_APP_URL}/dossiers/${props.currentAIAgent.externalId}/summaries/${props.summary.id}`,
                            '_blank',
                        )
                    }
                >
                    {translate(`file.pivot.aiagent.${props.agent.toLowerCase().replaceAll('_', '-')}.interaction.summary.open`)}
                </Button>
                <Text size={500}>
                    {props.summary.title || translate('')} -{' '}
                    {translate(`file.pivot.aiagent.${props.agent.toLowerCase().replaceAll('_', '-')}.interaction.summary.version`, {
                        version: props.summary.preferredVersion.versionNumber,
                    })}
                </Text>
            </div>
            <RichText content={props.summary.preferredVersion.content} />
        </div>
    )
}
